// extracted by mini-css-extract-plugin
export var csatScore = "_n0-5";
export var header = "_n0-1";
export var panelWrapper = "_n0-2";
export var postPreview = "_n0-3";
export var rightContent = "_n0-0";
export var wrappingText = "_n0-4";